export default __webpack_public_path__ + "static/employee-benefits-hero-two-alt.url-45508033381be41909aa33cb4152d1af.svg";